import { stringify } from "query-string";
import { GET_LIST, GET_ONE, GET_MANY, GET_MANY_REFERENCE } from "react-admin";
import { QA_API_ERROR } from "../../util";

const LikeProvider = opt => {
  const { config, httpClient } = opt;
  if (!config) {
    throw new Error("Missing config");
  }
  if (!httpClient) {
    throw new Error("Missing httpClient");
  }
  const provider = {
    handle(type, params) {
      switch (type) {
        case GET_LIST:
          return provider.list(params);
        case GET_ONE:
          return provider.get(params);
        case GET_MANY:
          return provider.getMany(params);
        case GET_MANY_REFERENCE:
          return provider.list(params);
        default:
          throw new Error(`LikeProvider unsupported action type: ${type}`);
      }
    },
    get(params) {
      return httpClient
        .get(`/api/like/${params.id}`)
        .then(res => res.data)
        .then(result => {
          if (result.status !== "success") {
            throw QA_API_ERROR("LikeProvider.get Error", result, params);
          }
          let response = {
            data: result.like
          };
          return response;
        });
    },
    getMany(params) {
      const query = {
        ids: params.ids
      };
      return httpClient
        .get(`/api/admin/likes/list?${stringify(query)}`)
        .then(res => res.data)
        .then(result => {
          if (result.status !== "success") {
            throw QA_API_ERROR("LikeProvider.getMany Error", result, params);
          }
          const response = {
            data: result.likes || null
          };
          return response;
        });
    },
    list(params) {
      const query = {
        order: params.sort.field,
        sort: params.sort.order.toLowerCase(),
        limit: params.pagination.perPage
      };
      // target
      if (params.target === "targetId") {
        query.targetId = params.id;
      }
      if (params.target === "userId") {
        query.userId = params.id;
      }
      // filter
      if (params.filter.target) {
        if (params.filter.target.id) {
          query.targetId = params.filter.target.id;
        }
        if (params.filter.target.type) {
          query.targetType = params.filter.target.type;
        }
      }
      if (params.filter.question) {
        if (params.filter.question.id) {
          query.questionId = params.filter.question.id;
        }
      }
      if (params.filter.userId) {
        query.userId = params.filter.userId;
      }
      // pagination
      if (typeof params.pagination.page === "string") {
        const [pageNumber, afterOrBefore, id] = params.pagination.page.split(
          "_"
        );
        if (afterOrBefore === "after") {
          query.after = id;
        } else if (afterOrBefore === "before") {
          query.before = id;
        }
        console.log("pageNumber: ", pageNumber);
      }
      return httpClient
        .get(`/api/admin/likes/list?${stringify(query)}`)
        .then(res => res.data)
        .then(result => {
          if (result.status !== "success") {
            throw QA_API_ERROR("LikeProvider.list Error", result, params);
          }
          let response = {
            data: result.likes || null,
            total: 1000
          };
          return response;
        });
    }
  };
  return provider;
};

export default LikeProvider;
